module.exports = __webpack_public_path__ + "img/logo.7d072d83.svg";